import React from 'react'
import { useContext } from './Context'
import { FilterContainer } from './Filters/FilterContainer'
import { MobileSideBarContainer } from '../../../components/MobileSideBarContainer'

export const MobileFilterContainer = () => {
  const { showMobileFilter, setShowMobileFilter } = useContext()

  return (
    <MobileSideBarContainer onShow={setShowMobileFilter} show={showMobileFilter} header={<h2>Product Filter</h2>}>
      <FilterContainer />
    </MobileSideBarContainer>
  )
}
